<form [formGroup]="form">
    <h2 class="text-primary-900 text-base !font-medium !mb-2">
        Schedule D - Station Locations and Antenna Structures
    </h2>
    <div class="flex space-x-5 mb-4">
        <div class="flex space-x-2 items-center">
            <p class="!mb-0 text-primary-900 text-sm font-medium">
                Action Requested:
                <span class="text-primary-800">{{
                    form.controls.actionCode.value ?? 'None'
                }}</span>
            </p>
            <app-hover-tooltip
                [moreInfo]="true"
                [message]="messages.actionCodeTooltip"
            ></app-hover-tooltip>
        </div>
        <div class="flex space-x-2 items-center">
            <p class="!mb-0 text-primary-900 text-sm font-medium">
                Location Number:
                <span class="text-primary-800">{{
                    form.controls.number.value
                }}</span>
            </p>
            <app-dialog-tooltip
                [message]="messages.locationNumberTooltip"
                title="Location Number"
            ></app-dialog-tooltip>
        </div>
    </div>
    <div class="px-6">
        @switch (step()) {
            @case (1) {
                <app-schedule-d-step-one
                    [form]="form"
                    [atMaximumFixedLocations]="atMaximumFixedLocations"
                ></app-schedule-d-step-one>
            }
            @case (2) {
                <app-schedule-d-step-two
                    [form]="form"
                    [scheduleDs]="scheduleDs"
                ></app-schedule-d-step-two>
            }
            @case (3) {
                <app-schedule-d-step-three
                    [form]="form"
                ></app-schedule-d-step-three>
            }
        }
    </div>

    <nav
        aria-label="Location form navigation"
        class="flex items-center justify-between"
    >
        <!-- Needed to center step buttons -->
        <div class="flex-1"></div>
        <div
            class="flex flex-1 space-x-1 justify-center"
            aria-label="Step indicators"
        >
            @for (index of getStepRange(); track index) {
                <button
                    [class]="
                        step() === index
                            ? 'bg-secondary-500'
                            : 'bg-tertiary-200'
                    "
                    [attr.aria-current]="step() === index ? 'step' : null"
                    class="rounded-full h-3 w-3 focus:outline-1 outline-primary-700"
                    title="Step {{ index }}"
                    type="button"
                    disabled="true"
                ></button>
            }
        </div>
        <div class="flex flex-1 justify-end">
            @if (step() !== getFirstStep()) {
                @if (!isReadOnly()) {
                    <button
                        type="button"
                        color="primary"
                        (click)="submit()"
                        mat-stroked-button
                        class="mr-2 !text-tertiary-50 px-4 py-2 !rounded-lg !bg-tertiary-700 text-nowrap"
                    >
                        {{ navigationText.SAVE }}
                    </button>
                }
                <button
                    type="button"
                    color="primary"
                    (click)="previousStep()"
                    mat-stroked-button
                    class="mr-2 text-primary-700 px-4 py-2 !rounded-lg !border-primary-700"
                >
                    {{ navigationText.PREVIOUS }}
                </button>
            }
            <button
                type="button"
[disabled]="(stepValid$ | async) !== true"
                mat-raised-button
                (click)="nextAction()"
                color="primary"
                class="bg-primary-700 text-white px-4 py-2 !rounded-lg"
            >
                {{ getNextActionText() }}
            </button>
        </div>
    </nav>
</form>
